<div class="container d-flex flex-column h-100">
  <div class="d-flex flex-column flex-grow-1">
    <div class="d-flex justify-content-center">
      <h3>Select Company to Sign the Agreement</h3>
    </div>
    <mat-divider class="mb-3"></mat-divider>
    <div class="list-container">
      <mat-selection-list multiple="false" aria-label="Selection Company List">
        <ng-container *ngIf="customers.length === 0">
          <div class="p-4 mt-4">
            <h5 class="text-muted d-flex justify-content-center">No Companies Found</h5>
          </div>
        </ng-container>
        <mat-list-option #selectedCustomerOption *ngFor="let customer of customers" checkboxPosition="before" (click)="selectCustomer(customer)"
                         [selected]="customers.length === 1 || customer.customerIdentifier === selectedCustomer?.customerIdentifier"
                         aria-label="Company List Options">
          <div class="d-flex">
            <mat-radio-button [checked]="selectedCustomerOption.selected"></mat-radio-button>
            <div>{{ customer.customerName }}</div>
          </div>
        </mat-list-option>
      </mat-selection-list>
    </div>
  </div>
  <div class="d-flex justify-content-end pt-2">
    <button mat-flat-button matStepperNext color="accent" [disabled]="!selectedCustomer" (click)="next()" aria-label="Next Button">
      Next
    </button>
  </div>
</div>
